import PropTypes from 'prop-types';

import { useMessages } from '@zenbusiness/application-commons-intl';
import { ErrorBoundary } from '@zenbusiness/application-commons-logging';
import Stack from '@zenbusiness/zui/Stack';

import { NAME } from '#client/build-env';
import { ErrorStateSection } from '#client/components/ErrorStateSection';

import { EnterpriseNextUp } from './components/EnterpriseNextUp';
import { EnterpriseOrderTracker } from './components/EnterpriseOrderTracker';
import { EnterpriseProfileHeader } from './components/EnterpriseProfileHeader';

function EnterpriseHome({ enterprise }) {
  const messages = useMessages({
    nextUpTitle: 'dashboard.enterpriseNextUp.title',
    orderTrackerTitle: 'dashboard.orderTracker.title'
  });

  return (
    <Stack spacing={{ xs: 2, sm: 3 }}>
      <ErrorBoundary
        fallback={<ErrorStateSection />}
        id={`${NAME}/pages/EnterpriseHome#EnterpriseProfileHeader`}
      >
        <EnterpriseProfileHeader enterprise={enterprise} />
      </ErrorBoundary>

      <ErrorBoundary
        fallback={<ErrorStateSection title={messages.nextUpTitle} />}
        id={`${NAME}/pages/EnterpriseHome#EnterpriseNextUp`}
      >
        <EnterpriseNextUp />
      </ErrorBoundary>

      <ErrorBoundary
        fallback={<ErrorStateSection title={messages.orderTrackerTitle} />}
        id={`${NAME}/pages/EnterpriseHome#EnterpriseOrderTracker`}
      >
        <EnterpriseOrderTracker />
      </ErrorBoundary>
    </Stack>
  );
}

EnterpriseHome.propTypes = {
  enterprise: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  }).isRequired
};

export default EnterpriseHome;
